module.exports = __webpack_public_path__ + "img/seven.3e377eee.svg";